import { Component, OnInit } from '@angular/core';
import { PatientView } from 'src/app/model/patient';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PatientService } from 'src/app/services/patient.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-patient-crm-patient',
  templateUrl: './patient-crm-patient.component.html',
  styleUrls: ['./patient-crm-patient.component.css']
})
export class PatientCrmPatientComponent implements OnInit {

  loading: boolean;
  patient: PatientView;

  constructor(private notificationToastService: NotificationToastService,
    private patientService: PatientService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async (params) => {
      try { 
        this.patient = await this.patientService.getPatientView(params['Id']); 
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Paciente');
      } finally {
        this.loading = false;
      }
    }); 
  }

}
